import React from 'react'
import Pana from '../../../assets/panaV2.png';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';

export const TriadFirstTabV2: React.FC<{ triad: any, created: boolean }> = ({ triad, created }) => {
    return (
        <>
            {/* Description */}
            <p style={{ margin: "0 0 20px", fontSize: "15px", fontWeight: 400 }}>
                Call Flow, Sales and Compliance Focused Coaching is A3I A3I stands for Analyze, Align (via agent self-discovery) Agent Articulation of the Skill,
                & YOU Inspect what YOU Expect in Real-Time, the Interaction Between the Consumer and the Agent.
            </p>

            {/* Dates */}
            {created && (
                <div style={{ display: "flex", gap: "48px", marginBottom: "22px" }}>
                    {[
                        { label: "Observation Date", value: triad?.create_date ? DateTemplate(triad.create_date) : 'n/a' },
                        { label: "Team Lead Acknowledgment", value: triad?.acknowledged && triad?.acknowledge_date ? DateTemplate(triad.acknowledge_date) : 'n/a' },
                    ].map(({ label, value }) => (
                        <div key={label}>
                            <div style={{ fontSize: "12px", fontWeight: 600, color: "#111827", marginBottom: "3px" }}>{label}</div>
                            <div style={{ fontSize: "13px", color: "#374151" }}>{value}</div>
                        </div>
                    ))}
                </div>
            )}

            {/* Main 3-col row */}
            <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>

                {/* Scoring Scale */}
                <div style={{
                    flex: 1,
                    padding: "18px 20px",
                }}>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#111827", marginBottom: "14px" }}>
                        Scoring Scale
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                            { score: "2", label: "= Fully Met", desc: "Consistently demonstrated, effective and intentional" },
                            { score: "1", label: "= Partially Met", desc: "Demonstrated but inconsistent or needs strengthening" },
                            { score: "0", label: "= Not Met", desc: "Not demonstrated or ineffective" },
                            { score: "N/A", label: "= Not Applicable", desc: "Excluded from scoring" },
                        ].map(({ score, label, desc }) => (
                            <div key={score} style={{ display: "flex", alignItems: "flex-start", gap: "5px", fontSize: "13px" }}>
                                <span style={{ fontWeight: 700, minWidth: "25px", display: "inline-block" }}>{score}</span>
                                <span style={{ fontWeight: 400 }}><strong>{label}</strong> – {desc}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ width: '1px', height: '13rem', backgroundColor: '#e5e7eb', flexShrink: 0 }} />
                {/* Weight Scale */}
                <div style={{
                    flex: 1,
                    padding: "18px 20px",
                }}>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#111827", marginBottom: "14px" }}>
                        Weight Scale
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                            { label: "Framing the Conversation", pct: "15%" },
                            { label: "Understanding the Current State", pct: "20%" },
                            { label: "Exploring the Desired Goal", pct: "20%" },
                            { label: "Laying Out an Action Plan", pct: "35%" },
                        ].map(({ label, pct }, i) => (
                            <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#374151" }}>
                                <span>
                                    <span style={{ fontWeight: 700 }}>{i + 1}.&nbsp;</span>
                                    <span style={{ fontWeight: 400 }}>{label}</span>
                                </span>
                                <span style={{ fontWeight: 700, color: "#111827", marginLeft: "12px" }}>{pct}</span>
                            </div>
                        ))}
                        <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "8px", display: "flex", justifyContent: "flex-end" }}>
                            <span style={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>Total = 100%</span>
                        </div>
                    </div>
                </div>
                <div style={{ width: '1px', height: '13rem', backgroundColor: '#e5e7eb', flexShrink: 0 }} />
                {/* Illustration */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                    <img src={Pana} alt="pana" />
                </div>
            </div>
        </>
    )
}
